import {AbstractPointSnapStrategy} from './AbstractPointSnapStrategy';
import {PointSnapStrategyType} from './PointSnapStrategyType';
import type {PointSnapRequest, PointSnapResult} from './PointSnapTypes';

/**
 * 交叉点捕捉策略。
 */
export class IntersectionPointSnapStrategy extends AbstractPointSnapStrategy {
    /** 策略类型。 */
    public readonly strategyType: PointSnapStrategyType = PointSnapStrategyType.Intersection;

    /**
     * 执行交叉点捕捉。
     * @param request 点捕捉请求参数。
     * @returns 点捕捉结果。
     */
    public resolve(request: PointSnapRequest): PointSnapResult | null {
        void request;
        // 尚未实现，返回 null 表示无捕捉命中。
        return null;
    }
}
